export function isEuropeanStockProduct(product, item) {
  return (
    product?.source === "georgia" ||
    item?.source === "georgia" ||
    product?.visibility === "ondemand" ||
    item?.visibility === "ondemand" ||
    Boolean(product?.georgiaMeta) ||
    Boolean(item?.georgiaMeta)
  );
}
